<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-input
        v-model="query.fName"
        placeholder="区域名称"
        size="small"
        style="width: 200px"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_modify(null)"
        >新增</el-button
      >
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fName" label="区域名称" />
        <el-table-column prop="fNumber" label="区域编号" />
        <el-table-column prop="fDes" label="区域简介" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_modify(scope.row)"
                >查看</el-button
              >
            </template>
            <template>
              <ConfirmButton v-if="canDel" @confirm="_delete(scope.row)"
                >删除</ConfirmButton
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import EditForm from "./EditForm";
import ConfirmButton from "@components/ConfirmButton";

export default {
  components: {
    EditForm,
    ConfirmButton,
  },
  data() {
    return {
      query: {
        fName: null,
      },
      tableData: [],
      loading: false,
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canDel: true,
    };
  },
  mounted() {
    this.refresh();

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants;
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == "004001002") {
        this.canAdd = val.isGrant;
      }
      if (val.key == "004001003") {
        this.canEdit = val.isGrant;
      }
      if (val.key == "004001004") {
        this.canDel = val.isGrant;
      }
    });
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$httpPost("BasicInformation/Region/RegionEntry", this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message);
            return;
          }

          this.tableData = res.datalist;
        })
        .finally(() => (this.loading = false));
    },
    _modify: async function (row) {
      const isNew = !row;
      if (isNew) {
        this.currentEditItem = {
          fName: null,
          fNumber: null,
          fDes: null,
        };
      } else {
        this.currentEditItem = await this.$httpPost(
          "BasicInformation/Region/GetRegion",
          { fid: row.fRegionID }
        ).then((res) => res.datalist);
      }
      let or;
      if (isNew) {
        or = this.canAdd;
      } else {
        or = this.canEdit;
      }
      const h = this.$createElement;
      this.$formDlg({
        title: isNew ? "新建区域" : `查看区域`,
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew ? 0 : 1, formData),
        width: "30%",
        readonly: !or,
      });
    },
    _delete(row) {
      this.postData(2, row);
    },
    postData(modifyType, info) {
      return this.$httpPost(`BasicInformation/Region/RegionModify`, {
        datalist: JSON.stringify({
          modifyType,
          info,
        }),
      }).then(async (res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
    dateFormat: function (row, column, cellValue) {
      var date = cellValue;
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
